<dialog
  #dialog
  [ngClass]="{
    'modal-background': true,
    'modal-background--managed': !instanceIsStandalone,
    'modal-show': showModal,
    'modal-fade': instanceShouldFade,
    'modal-did-fade-in': hasFadedIn,
    'modal-no-overlay': !useBackgroundOverlay
  }"
  cdkTrapFocus
  >
  <div [class]="['modal-dialog', modalSize ? 'modal--' + modalSize : '']" appModalDialog>
    <div class="modal-content">
      @if (modalTitle$ | async) {
        <div class="modal-header">
          <h3 class="modal-title" data-testid="modal-header">{{ modalTitle$ | async }}</h3>
        </div>
      }
      <div
        [ngClass]="{
        'modal-body': true,
        'modal-body--standalone': instanceIsStandalone,
      }"
        >
        <ng-template appModalContent></ng-template>
      </div>
      @if (allowManualClose) {
        <app-button-container>
          <app-button type="primary" (click)="handleDialogClose()" [dataTestId]="'modal-close'">
            Close
          </app-button>
        </app-button-container>
      }
    </div>
  </div>
</dialog>
